export default "__VITE_ASSET__BFGwCn23__"